module.exports = __webpack_public_path__ + "static/media/2 5 Ordkjedetest-Riktig.0eee813d.mp3";